export const _ADD               = "iVPc9PCeqSFh2yINmjMw5Q==";
export const _EDIT              = "15R2MyJpHUvVq4ceUG/1Fg==";
export const _VIEW              = "9nBdRnLsybVwgClqsXOzpw==";
export const _DELETE            = "lOtJyehxRrxgfdzGWbQv6cmolCDPzyGdX+JQTBvl7zA=";
export const _RECOVER           = "Ktztzke2GM+SDTesqx2/T4+y8rJ0Ou5QEkBEQlWDQ00=";
export const _LIST              = "rJ8m2tTYhegFlfjLZPgv6A==";
export const _TRASH             = "LCKdSTbmQTfwuegrH2x/rA==";